import React, { useContext } from 'react'

import { CardContent, CardFooter, CardHeading } from '../../../../components/layout/Card'
import { Button } from '../../../../components/Button'
import { RemindersContext } from '../../context'
import CancelIcon from '@material-ui/icons/Cancel'

export const Error = () => {
  const {
    state: { message }
  } = useContext(RemindersContext)

  return (
    <>
      <CardHeading>
        <h5>Reminders</h5>
      </CardHeading>
      <CardContent className='wealth-manager-reminders__error'>
        <CancelIcon className='wealth-manager-reminders__error__icon' />
        <p>{message}. Please go back and try again, or contact support if it persists</p>
        <Actions />
      </CardContent>
    </>
  )
}

const Actions = () => {
  const {
    actions: { cancel }
  } = useContext(RemindersContext)

  return (
    <CardFooter className='wealth-manager-reminders__form__actions'>
      <Button
        primary
        onClick={cancel}
        trackAs='Reminder: Cancel'
      >
        Go Back
      </Button>
    </CardFooter>
  )
}
